module.exports = __webpack_public_path__ + "img/master_equipment.bc96f6b4.png";